const sparePartTypeEnum = Object.freeze({
    breakdown: "UnPlanned",
    planned: "Planned",
    sparePart: "SparePart"
})

export default sparePartTypeEnum;